import React, { useState, useEffect } from 'react';
import './App.css';
import { Link } from 'react-router-dom';
import { supabase } from './supabase';

// Default artwork from Shop page (all Prints category items)
const defaultArtwork = [
  { id: 7, name: 'Sacred Geometry Crystal', price: 2.00, img: 'https://i.postimg.cc/025M3Y7J/Whats-App-Image-2025-07-24-at-8-54-24-PM.jpg' },
  { id: 8, name: 'Mystical Moon Crystal', price: 2.00, img: 'https://i.postimg.cc/8z97jx9h/Whats-App-Image-2025-07-24-at-9-19-22-PM.jpg' },
  { id: 9, name: 'Rose Quartz Healing Crystal', price: 2.00, img: 'https://i.postimg.cc/CxzZMwPh/Whats-App-Image-2025-07-24-at-9-19-23-PM-1.jpg' },
  { id: 10, name: 'Amethyst Spiritual Crystal', price: 2.00, img: 'https://i.postimg.cc/bN6DjZRV/Whats-App-Image-2025-07-24-at-9-19-23-PM-2.jpg' },
  { id: 11, name: 'Citrine Abundance Crystal', price: 2.00, img: 'https://i.postimg.cc/rmCsZsmJ/Whats-App-Image-2025-07-25-at-6-52-22-PM.jpg' },
  { id: 12, name: 'Lapis Lazuli Wisdom Crystal', price: 2.00, img: 'https://i.postimg.cc/PJSxh71v/Whats-App-Image-2025-07-25-at-6-52-22-PM-1.jpg' },
  { id: 13, name: 'Tiger Eye Protection Crystal', price: 2.00, img: 'https://i.postimg.cc/1tZ4Kw9X/Whats-App-Image-2025-07-25-at-6-52-22-PM-2.jpg' },
  { id: 14, name: 'Clear Quartz Master Crystal', price: 2.00, img: 'https://i.postimg.cc/GmWpcGTK/Whats-App-Image-2025-07-25-at-6-52-23-PM.jpg' },
  { id: 15, name: 'Black Obsidian Grounding Crystal', price: 2.00, img: 'https://i.postimg.cc/Wb4zS2PG/Whats-App-Image-2025-07-25-at-6-52-23-PM-1.jpg' },
  { id: 16, name: 'Green Aventurine Luck Crystal', price: 2.00, img: 'https://i.postimg.cc/c1h6QvP1/Whats-App-Image-2025-07-25-at-6-52-23-PM-2.jpg' },
  { id: 17, name: 'Selenite Cleansing Crystal', price: 2.00, img: 'https://i.postimg.cc/cCxHpWtN/Whats-App-Image-2025-07-25-at-6-52-23-PM-3.jpg' },
  { id: 18, name: 'Malachite Transformation Crystal', price: 2.00, img: 'https://i.postimg.cc/sXyDWzcZ/Whats-App-Image-2025-07-25-at-6-52-24-PM.jpg' },
  { id: 19, name: 'Labradorite Magic Crystal', price: 2.00, img: 'https://i.postimg.cc/Gpvm9tkC/Whats-App-Image-2025-07-25-at-6-52-24-PM-1.jpg' },
  { id: 20, name: 'Carnelian Vitality Crystal', price: 2.00, img: 'https://i.postimg.cc/L60XbrHr/Whats-App-Image-2025-07-25-at-6-52-24-PM-2.jpg' },
  { id: 21, name: 'Fluorite Clarity Crystal', price: 2.00, img: 'https://i.postimg.cc/3rtJkPDd/Whats-App-Image-2025-07-25-at-6-52-25-PM.jpg' },
  { id: 22, name: 'Hematite Strength Crystal', price: 2.00, img: 'https://i.postimg.cc/T1NRBDXr/Whats-App-Image-2025-07-25-at-6-52-25-PM-1.jpg' },
  { id: 23, name: 'Jade Harmony Crystal', price: 2.00, img: 'https://i.postimg.cc/j5XqQ1g3/Whats-App-Image-2025-07-25-at-6-52-25-PM-2.jpg' },
  { id: 24, name: 'Healing Crystal Print', price: 2.00, img: 'https://i.postimg.cc/rwf5whNT/Whats-App-Image-2025-07-23-at-10-10-16-PM.jpg' },
  { id: 25, name: 'Spiritual Crystal Print', price: 2.00, img: 'https://i.postimg.cc/nLMBjv3D/Whats-App-Image-2025-07-23-at-10-10-17-PM.jpg' },
  { id: 26, name: 'Mystical Crystal Print', price: 2.00, img: 'https://i.postimg.cc/3w6pgdqb/Whats-App-Image-2025-07-23-at-10-13-17-PM.jpg' },
  { id: 27, name: 'Sacred Crystal Print', price: 2.00, img: 'https://i.postimg.cc/MTQBtz2Z/Whats-App-Image-2025-07-23-at-10-22-29-PM.jpg' },
  { id: 28, name: 'Divine Crystal Print', price: 2.00, img: 'https://i.postimg.cc/rs2rP7M1/Whats-App-Image-2025-07-23-at-10-42-37-PM.jpg' },
  { id: 29, name: 'Ancient Crystal Print', price: 2.00, img: 'https://i.postimg.cc/pThf7D8H/Whats-App-Image-2025-07-23-at-5-28-43-PM.jpg' },
  { id: 30, name: 'Cosmic Crystal Print', price: 2.00, img: 'https://i.postimg.cc/R00Q1rZq/Whats-App-Image-2025-07-23-at-5-28-43-PM-1.jpg' },
  { id: 31, name: 'Ethereal Crystal Print', price: 2.00, img: 'https://i.postimg.cc/kgqy4RrQ/Whats-App-Image-2025-07-23-at-5-28-43-PM-2.jpg' },
  { id: 32, name: 'Celestial Crystal Print', price: 2.00, img: 'https://i.postimg.cc/FRMyQ7gJ/Whats-App-Image-2025-07-23-at-5-28-44-PM.jpg' },
  { id: 33, name: 'Enchanted Crystal Print', price: 2.00, img: 'https://i.postimg.cc/y8jyS6Bw/Whats-App-Image-2025-07-23-at-5-28-44-PM-1.jpg' },
  { id: 34, name: 'Magical Crystal Print', price: 2.00, img: 'https://i.postimg.cc/1zY0JW8B/Whats-App-Image-2025-07-23-at-5-28-44-PM-2.jpg' },
  { id: 35, name: 'Serene Crystal Print', price: 2.00, img: 'https://i.postimg.cc/3rGjFFYj/Whats-App-Image-2025-07-23-at-5-28-45-PM.jpg' },
  { id: 36, name: 'Tranquil Crystal Print', price: 2.00, img: 'https://i.postimg.cc/rs5SyMQZ/Whats-App-Image-2025-07-23-at-6-32-42-PM.jpg' },
  { id: 37, name: 'Peaceful Crystal Print', price: 2.00, img: 'https://i.postimg.cc/wTdXfRjC/Whats-App-Image-2025-07-23-at-9-36-17-PM.jpg' },
  { id: 38, name: 'Calming Crystal Print', price: 2.00, img: 'https://i.postimg.cc/wjqhHKJF/Whats-App-Image-2025-07-23-at-9-36-18-PM.jpg' },
  { id: 39, name: 'Soothing Crystal Print', price: 2.00, img: 'https://i.postimg.cc/m2NQ0Zct/Whats-App-Image-2025-07-23-at-9-36-18-PM-1.jpg' },
  { id: 40, name: 'Harmonious Crystal Print', price: 2.00, img: 'https://i.postimg.cc/KctLMcDJ/Whats-App-Image-2025-07-24-at-4-00-53-PM.jpg' },
  { id: 41, name: 'Balanced Crystal Print', price: 2.00, img: 'https://i.postimg.cc/nrKDbTh6/Whats-App-Image-2025-07-24-at-6-38-29-PM.jpg' },
  { id: 42, name: 'Centered Crystal Print', price: 2.00, img: 'https://i.postimg.cc/hPrd2Cwm/Whats-App-Image-2025-07-24-at-6-38-31-PM.jpg' },
  { id: 43, name: 'Aligned Crystal Print', price: 2.00, img: 'https://i.postimg.cc/9FV9t3xV/Whats-App-Image-2025-07-24-at-6-42-26-PM.jpg' },
  { id: 44, name: 'Connected Crystal Print', price: 2.00, img: 'https://i.postimg.cc/6ppGgrJm/Whats-App-Image-2025-07-24-at-7-21-15-PM.jpg' },
  { id: 45, name: 'Mystical Energy Crystal', price: 2.00, img: 'https://i.postimg.cc/6pbGX8B5/Whats-App-Image-2025-07-24-at-7-21-40-PM.jpg' },
  { id: 46, name: 'Sacred Light Crystal', price: 2.00, img: 'https://i.postimg.cc/7LCJYqL1/Whats-App-Image-2025-07-24-at-7-34-17-PM.jpg' },
  { id: 47, name: 'Divine Protection Crystal', price: 2.00, img: 'https://i.postimg.cc/QMR9FvB2/Whats-App-Image-2025-07-24-at-8-13-42-PM.jpg' },
  { id: 48, name: 'Spiritual Awakening Crystal', price: 2.00, img: 'https://i.postimg.cc/5ym6k0PJ/Whats-App-Image-2025-07-24-at-8-13-43-PM.jpg' },
  { id: 49, name: 'Cosmic Wisdom Crystal', price: 2.00, img: 'https://i.postimg.cc/hvnXrx1M/Whats-App-Image-2025-07-24-at-8-13-43-PM-1.jpg' },
  { id: 50, name: 'Ethereal Beauty Crystal', price: 2.00, img: 'https://i.postimg.cc/W3gDgSgh/Whats-App-Image-2025-07-24-at-8-13-43-PM-2.jpg' },
  { id: 51, name: 'Enchanted Spirit Crystal', price: 2.00, img: 'https://i.postimg.cc/sfPQ263L/Whats-App-Image-2025-07-24-at-8-13-44-PM.jpg' },
  { id: 52, name: 'Magical Essence Crystal', price: 2.00, img: 'https://i.postimg.cc/zXJLHCBG/Whats-App-Image-2025-07-24-at-8-13-53-PM.jpg' },
  { id: 53, name: 'Celestial Harmony Crystal', price: 2.00, img: 'https://i.postimg.cc/XYPXPtgr/Whats-App-Image-2025-07-24-at-8-44-55-PM.jpg' },
  { id: 54, name: 'Mystical Aura Crystal', price: 2.00, img: 'https://i.postimg.cc/yNSW-Cnfv/Whats-App-Image-2025-07-24-at-8-44-56-PM-2.jpg' },
  { id: 55, name: 'Sacred Essence Crystal', price: 2.00, img: 'https://i.postimg.cc/C1T5hDXY/Whats-App-Image-2025-07-24-at-8-44-56-PM-1.jpg' },
  { id: 56, name: 'Divine Radiance Crystal', price: 2.00, img: 'https://i.postimg.cc/zBCBVvYh/Whats-App-Image-2025-07-24-at-8-44-56-PM.jpg' },
  { id: 57, name: 'Spiritual Serenity Crystal', price: 2.00, img: 'https://i.postimg.cc/CLmRGRBH/Whats-App-Image-2025-07-24-at-8-44-55-PM-2.jpg' },
  { id: 58, name: 'Cosmic Tranquility Crystal', price: 2.00, img: 'https://i.postimg.cc/Z5nCVJ6k/Whats-App-Image-2025-07-24-at-8-44-55-PM-1.jpg' },
  { id: 59, name: 'Mystical Crystal Art', price: 2.00, img: 'https://i.postimg.cc/mDbBDwLY/Whats-App-Image-2025-07-26-at-7-22-25-PM-1.jpg' },
  { id: 60, name: 'Sacred Crystal Design', price: 2.00, img: 'https://i.postimg.cc/JhC1w8Sd/Whats-App-Image-2025-07-26-at-7-22-25-PM-2.jpg' },
  { id: 61, name: 'Divine Crystal Pattern', price: 2.00, img: 'https://i.postimg.cc/HWvdYXfM/Whats-App-Image-2025-07-26-at-7-22-26-PM.jpg' },
  { id: 62, name: 'Spiritual Crystal Essence', price: 2.00, img: 'https://i.postimg.cc/tJJbd4V7/Whats-App-Image-2025-07-26-at-7-22-26-PM-1.jpg' },
  { id: 63, name: 'Cosmic Crystal Energy', price: 2.00, img: 'https://i.postimg.cc/zX9NW5DX/Whats-App-Image-2025-07-26-at-7-22-27-PM.jpg' },
  { id: 64, name: 'Ethereal Crystal Beauty', price: 2.00, img: 'https://i.postimg.cc/CLZYzdgQ/Whats-App-Image-2025-07-26-at-7-22-27-PM-1.jpg' },
  { id: 65, name: 'Mystical Crystal Harmony', price: 2.00, img: 'https://i.postimg.cc/yNTCwZmk/Whats-App-Image-2025-07-26-at-7-22-30-PM.jpg' },
  { id: 66, name: 'Sacred Crystal Radiance', price: 2.00, img: 'https://i.postimg.cc/DwLTPDmQ/Whats-App-Image-2025-07-26-at-7-22-30-PM-1.jpg' },
  { id: 67, name: 'Divine Crystal Serenity', price: 2.00, img: 'https://i.postimg.cc/MTKJxp5t/Whats-App-Image-2025-07-26-at-7-22-31-PM.jpg' },
  { id: 68, name: 'Spiritual Crystal Wisdom', price: 2.00, img: 'https://i.postimg.cc/vT4Rg2pV/Whats-App-Image-2025-07-29-at-7-12-34-PM.jpg' },
  { id: 69, name: 'Cosmic Crystal Balance', price: 2.00, img: 'https://i.postimg.cc/XJHSv6DW/Whats-App-Image-2025-07-29-at-7-12-34-PM-1.jpg' },
  { id: 70, name: 'Ethereal Crystal Essence', price: 2.00, img: 'https://i.postimg.cc/qqSP8XTZ/Whats-App-Image-2025-07-31-at-8-49-07-PM.jpg' },
  { id: 71, name: 'Mystical Crystal Tranquility', price: 2.00, img: 'https://i.postimg.cc/T3M819QK/Whats-App-Image-2025-07-31-at-8-49-08-PM.jpg' },
  { id: 72, name: 'Sacred Crystal Peace', price: 2.00, img: 'https://i.postimg.cc/ZKytJgPk/Whats-App-Image-2025-07-31-at-8-49-08-PM-1.jpg' },
  { id: 73, name: 'Divine Crystal Calm', price: 2.00, img: 'https://i.postimg.cc/fWPQnZ9j/Whats-App-Image-2025-07-31-at-8-49-08-PM-2.jpg' },
  { id: 74, name: 'Spiritual Crystal Enlightenment', price: 2.00, img: 'https://i.postimg.cc/13pkqqYJ/Whats-App-Image-2025-08-05-at-9-06-42-PM.jpg' }
];

function ArtPrints() {
  const [artwork, setArtwork] = useState(defaultArtwork);
  const [form, setForm] = useState({ name: '', email: '', request: '' });
  const [submitted, setSubmitted] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalArt, setModalArt] = useState(null);
  const [orderForm, setOrderForm] = useState({ name: '', email: '', phone: '' });
  const [orderSubmitted, setOrderSubmitted] = useState(false);

  // Load artwork from Shop products (Prints category) if available
  useEffect(() => {
    const savedProducts = localStorage.getItem('shopProducts');
    if (savedProducts) {
      const products = JSON.parse(savedProducts);
      const prints = products.filter(p => p.category === 'Prints');
      if (prints.length > 0) {
        setArtwork(prints);
      }
    }
  }, []);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    
    try {
      const customRequestData = {
        name: form.name,
        email: form.email,
        request: form.request,
        status: 'pending'
      };
      
      const { error } = await supabase
        .from('art_custom_requests')
        .insert([customRequestData]);
      
      if (error) throw error;
      
      setTimeout(() => setSubmitted(false), 2500);
    } catch (error) {
      console.error('Error saving custom request:', error);
      setTimeout(() => setSubmitted(false), 2500);
    }
  };

  const openOrderModal = (art) => {
    setModalArt(art);
    setOrderForm({ name: '', email: '', phone: '' });
    setOrderSubmitted(false);
    setModalOpen(true);
  };
  const closeOrderModal = () => setModalOpen(false);
  const handleOrderChange = e => {
    setOrderForm({ ...orderForm, [e.target.name]: e.target.value });
  };
  const handleOrderSubmit = async (e) => {
    e.preventDefault();
    setOrderSubmitted(true);
    
    try {
      const printOrderData = {
        name: orderForm.name,
        email: orderForm.email,
        phone: orderForm.phone,
        art_name: modalArt?.name || modalArt?.title || '',
        art_id: modalArt?.id?.toString() || null,
        art_image_url: modalArt?.img || null,
        status: 'pending'
      };
      
      const { error } = await supabase
        .from('art_print_orders')
        .insert([printOrderData]);
      
      if (error) throw error;
      
      setTimeout(() => setModalOpen(false), 2000);
    } catch (error) {
      console.error('Error saving print order:', error);
      setTimeout(() => setModalOpen(false), 2000);
    }
  };

  return (
    <div className="main-bg">
      <header className="hero-section">
        <h1 className="site-title">Art & Prints</h1>
        <p className="site-tagline">Download spiritual artwork, order physical prints or canvas, and request custom creations.</p>
      </header>
      <div className="art-section">
        <div className="art-list">
          {artwork.map((art) => (
            <div className="art-card" key={art.id}>
              <img src={art.img} alt={art.name} className="art-img" />
              <h3>{art.name}</h3>
              <p>Beautiful spiritual crystal artwork. Available as digital download or physical print.</p>
              <div className="art-actions">
                <button className="art-btn" onClick={() => openOrderModal(art)}>Order Print/Canvas</button>
              </div>
            </div>
          ))}
        </div>
        <div className="custom-section">
          <h3>Customization Request</h3>
          <p>Want a custom piece or personalized destiny card? Fill out the form below and we'll get in touch!</p>
          <form className="custom-form" onSubmit={handleSubmit}>
            <input name="name" type="text" placeholder="Your Name" value={form.name} onChange={handleChange} required />
            <input name="email" type="email" placeholder="Your Email" value={form.email} onChange={handleChange} required />
            <textarea name="request" placeholder="Describe your custom art request" value={form.request} onChange={handleChange} rows={3} required />
            <button type="submit" className="art-btn">Send Request</button>
            {submitted && <div className="custom-success">Request sent! We'll contact you soon.</div>}
          </form>
        </div>
      </div>
      {modalOpen && (
        <div className="modal-overlay" onClick={closeOrderModal}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <button className="modal-close" onClick={closeOrderModal}>&times;</button>
            <h3>Order Print/Canvas: {modalArt?.name || modalArt?.title}</h3>
            <img src={modalArt?.img} alt={modalArt?.name || modalArt?.title} className="art-img" style={{ marginBottom: 12 }} />
            {!orderSubmitted ? (
              <form className="custom-form" onSubmit={handleOrderSubmit}>
                <input name="name" type="text" placeholder="Your Name" value={orderForm.name} onChange={handleOrderChange} required />
                <input name="email" type="email" placeholder="Your Email" value={orderForm.email} onChange={handleOrderChange} required />
                <input name="phone" type="tel" placeholder="Phone Number" value={orderForm.phone} onChange={handleOrderChange} required />
                <button type="submit" className="art-btn">Submit</button>
              </form>
            ) : (
              <div className="custom-success">Our team will contact you shortly.</div>
            )}
          </div>
        </div>
      )}
      <footer className="footer">
        <p>&copy; {new Date().getFullYear()} Life Force Dynamics. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default ArtPrints; 